import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { hasAnyAdminRole } from '@rb/shared/admin';
import { useAdminAuth } from './use-admin-auth';

/**
 * Sits inside AuthGate. Renders children only when the Privy wallet is on the
 * admin allowlist; otherwise redirects to /not-admin.
 */
export function AdminGate({ children }: { children: ReactNode }) {
  const { account } = useAdminAuth();
  if (!account || !hasAnyAdminRole(account)) {
    return <Navigate to="/not-admin" replace />;
  }
  return <>{children}</>;
}
